import AboutCompany from "../../common/aboutCompany/AboutCompany"

const AboutCompanyPage = () => {
   return (
      <AboutCompany />
   )
}

export default AboutCompanyPage